<template>
  <div v-if="title || description || $slots.default || $slots.title" class="info-banner" :class="color ? `info-banner--${color}` : ''">
    <i class="fa-duotone info-banner__icon" :class="resolvedIcon"></i>
    <div class="info-banner__body">
      <span v-if="$slots.title || title" class="info-banner__title">
        <slot name="title">{{ title }}</slot>
      </span>
      <span v-if="description" class="info-banner__desc" v-html="description"></span>
      <div v-if="$slots.default" class="info-banner__actions">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
const ICON_MAP = {
  green:  'fa-circle-check',
  orange: 'fa-triangle-exclamation',
  red:    'fa-circle-xmark',
  blue:   'fa-circle-info',
};

export default {
  props: {
    title:       { type: String, default: '' },
    description: { type: String, default: '' },
    // green | orange | red | blue | '' (default gray)
    color:       { type: String, default: '' },
    // override auto-selected icon
    icon:        { type: String, default: '' },
  },

  computed: {
    resolvedIcon() {
      return this.icon || ICON_MAP[this.color] || 'fa-circle-info';
    },
  },
};
</script>

<style lang="scss" scoped>
.info-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 16px;
  background: #f8f9fb;
  border: 1px solid #e4e8ed;
  border-radius: 6px;

  &__icon {
    color: #9aa5b4;
    font-size: 15px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 13px;
    font-weight: 500;
    color: #4a5568;
    line-height: 1.4;
  }

  &__desc {
    font-size: 13px;
    color: #718096;
    line-height: 1.4;
  }

  &__actions {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  // — Color variants —

  &--green {
    background: rgba(34, 197, 94, .08);
    border-color: rgba(34, 197, 94, .25);

    .info-banner__icon  { color: rgba(21, 128, 61, .85); }
    .info-banner__title { color: rgba(21, 128, 61, .95); }
    .info-banner__desc  { color: rgba(21, 128, 61, .75); }
  }

  &--orange {
    background: rgba(245, 158, 11, .08);
    border-color: rgba(245, 158, 11, .28);

    .info-banner__icon  { color: rgba(180, 83, 9, .85); }
    .info-banner__title { color: rgba(180, 83, 9, .95); }
    .info-banner__desc  { color: rgba(180, 83, 9, .75); }
  }

  &--red {
    background: rgba(239, 68, 68, .08);
    border-color: rgba(239, 68, 68, .25);

    .info-banner__icon  { color: rgba(185, 28, 28, .85); }
    .info-banner__title { color: rgba(185, 28, 28, .95); }
    .info-banner__desc  { color: rgba(185, 28, 28, .75); }
  }

  &--blue {
    background: rgba(37, 99, 235, .07);
    border-color: rgba(37, 99, 235, .22);

    .info-banner__icon  { color: rgba(30, 64, 175, .85); }
    .info-banner__title { color: rgba(30, 64, 175, .95); }
    .info-banner__desc  { color: rgba(30, 64, 175, .75); }
  }
}
</style>
